import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Lightbox from "@/components/Lightbox";

const PhotoTile = ({ photo, onClick, testId }) => (
  <button
    onClick={onClick}
    className="item group block w-full overflow-hidden bg-paper-alt text-left relative"
    data-testid={testId}
  >
    <div className="relative overflow-hidden">
      <img
        src={photo.src}
        alt={photo.alt || ""}
        loading="lazy"
        className="w-full h-auto block photo-zoom"
        style={{ aspectRatio: `${photo.w} / ${photo.h}` }}
      />
      {photo.quote && (
        <div className="absolute inset-0 flex items-end p-5 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <p className="font-display italic text-paper text-base sm:text-lg leading-snug">«{photo.quote}»</p>
        </div>
      )}
    </div>
  </button>
);

function Gallery({ photos, kicker, title, subtitle, testId, gridClassName = "masonry" }) {
  const [idx, setIdx] = useState(null);
  const close = () => setIdx(null);
  const next = () => setIdx((i) => (i + 1) % photos.length);
  const prev = () => setIdx((i) => (i - 1 + photos.length) % photos.length);

  return (
    <div className="pt-28 sm:pt-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <Link
          to="/"
          data-testid="gallery-back"
          className="inline-flex items-center gap-2 font-mono text-[0.7rem] tracking-[0.35em] uppercase text-muted hover:text-ink transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Home
        </Link>

        <div className="flex items-end justify-between gap-6 mb-12 sm:mb-16">
          <div>
            <p className="overline mb-3">{kicker}</p>
            <h1 className="display-xl text-[2.6rem] sm:text-[4rem] lg:text-[5rem] leading-[0.95]">
              {title}
            </h1>
            {subtitle && (
              <p className="font-display italic text-lg sm:text-xl text-muted mt-2">{subtitle}</p>
            )}
          </div>
          <div className="hidden sm:block font-mono text-[0.7rem] tracking-[0.35em] uppercase text-muted text-right">
            {String(photos.length).padStart(2, "0")} scatti
          </div>
        </div>

        <div className={gridClassName} data-testid={testId}>
          {photos.map((p, i) => (
            <PhotoTile
              key={p.src}
              photo={p}
              onClick={() => setIdx(i)}
              testId={`${testId}-tile-${i}`}
            />
          ))}
        </div>

        <Link
          to="/"
          data-testid="gallery-back-bottom"
          className="mt-16 mb-20 inline-flex items-center gap-2 font-mono text-[0.7rem] tracking-[0.35em] uppercase text-muted hover:text-ink transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla Home
        </Link>
      </div>

      {idx !== null && (
        <Lightbox photos={photos} index={idx} onClose={close} onNext={next} onPrev={prev} />
      )}
    </div>
  );
}

export default Gallery;
